import { Mail, Phone, MapPin } from "lucide-react";
import { Reveal } from "../components/site/Reveal";
import { ContactForm } from "../components/site/ContactForm";

export default function ContactPage() {
  return (
    <div data-testid="contact-page" className="bg-zinc-950">
      <section className="pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <div className="text-[11px] tracking-[0.3em] uppercase text-zinc-500">
              — Begin a Project
            </div>
            <h1 className="mt-6 font-serif font-light text-5xl sm:text-6xl lg:text-7xl xl:text-8xl tracking-tighter text-zinc-100 leading-[1.02] max-w-5xl">
              Let&apos;s talk about your{" "}
              <span className="italic text-zinc-300">build.</span>
            </h1>
            <p className="mt-8 text-zinc-400 text-lg max-w-2xl leading-relaxed">
              Whether you&apos;re an architect with a project ready to price, or a
              private client at the beginning of a brief — we welcome an early
              conversation.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
          {/* CONTACT INFO */}
          <aside className="md:col-span-4 md:sticky md:top-32">
            <Reveal>
              <div className="text-[11px] tracking-[0.3em] uppercase text-zinc-500 mb-8">
                — Direct
              </div>
              <div className="space-y-8">
                <a
                  href="mailto:info@tidemarkbuildingco.com.au"
                  data-testid="contact-email-link"
                  className="group flex items-start gap-4"
                >
                  <Mail
                    size={18}
                    strokeWidth={1.5}
                    className="text-zinc-500 group-hover:text-zinc-100 mt-1"
                  />
                  <div>
                    <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                      Email
                    </div>
                    <div className="mt-1 font-serif text-xl text-zinc-100 group-hover:text-white">
                      info@tidemarkbuildingco.com.au
                    </div>
                  </div>
                </a>

                <a
                  href="tel:+61403863435"
                  data-testid="contact-phone-link"
                  className="group flex items-start gap-4"
                >
                  <Phone
                    size={18}
                    strokeWidth={1.5}
                    className="text-zinc-500 group-hover:text-zinc-100 mt-1"
                  />
                  <div>
                    <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                      Phone
                    </div>
                    <div className="mt-1 font-serif text-xl text-zinc-100 group-hover:text-white">
                      0403 863 435
                    </div>
                  </div>
                </a>

                <div className="flex items-start gap-4">
                  <MapPin
                    size={18}
                    strokeWidth={1.5}
                    className="text-zinc-500 mt-1"
                  />
                  <div>
                    <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">
                      Based
                    </div>
                    <div className="mt-1 font-serif text-xl text-zinc-100">
                      Melbourne · Bayside, Victoria
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-12 pt-8 border-t border-zinc-900 text-zinc-500 text-sm leading-relaxed">
                Registered Building Practitioner · Victoria, Australia. DB-U 63884.
              </div>
            </Reveal>
          </aside>

          {/* FORM */}
          <div className="md:col-span-8">
            <Reveal delay={0.1}>
              <ContactForm idPrefix="contact" />
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
